// Libs
import React from 'react'

// CSS
import './styles.scss'

// Component/Container
import BadgeIcon from '../../../../components/BadgeIcon'
import ProfileIcon from '../../../../components/ProfileIcon'
import HeaderMobileLink from '../HeaderMobileLink'

const HeaderMobile = ({ visible, role, name, surname, image, group, lawFirm, admin, notifications, onClick, onSwap, onLogout, capture, ...props }) => {
  const full_name = `${name} ${surname}`

  return (
    <div className={visible ? "header-mobile header-mobile--visible" : "header-mobile"}>
      {role === 'company' &&
        <div>
          <HeaderMobileLink onClick={onClick} to="/dashboard">Dashboard</HeaderMobileLink>
          <hr />
          {capture &&
            <div>
              <HeaderMobileLink onClick={onClick} to="/captacao">Captação</HeaderMobileLink>
              <hr />
            </div>
          }
          <HeaderMobileLink onClick={onClick} to="/inserir-caso-contencioso">Inserir Caso</HeaderMobileLink>
          <hr />
          {admin &&
            <div>
              <HeaderMobileLink onClick={onClick} to="/importador/contatos">Inserir Contato</HeaderMobileLink>
              <hr />
            </div>
          }
        </div>
      }
      <HeaderMobileLink onClick={onClick} to="/meus-casos">Meus Casos</HeaderMobileLink>
      <hr />
      <HeaderMobileLink height={160} padding="0 20%" onClick={onClick} to="/perfil">
        <div className="header-mobile__profile">
          <ProfileIcon
            image={image + '/big'}
            width={70}
            fontSize={15}
            lawyerName={role === 'lawyer' ? full_name : null}
            companyName={role === 'company' ? full_name : null} />
          <p>{name} {surname ? surname.toUpperCase().charAt(0) : ''}.</p>
          <p>{lawFirm ? lawFirm : group}</p>
        </div>
      </HeaderMobileLink>
      <hr />
      <HeaderMobileLink onClick={onLogout} to="/login">Sair</HeaderMobileLink>
    </div>
  )
}

export default HeaderMobile
